import { config } from '@/config';
import { _s } from '@/locale';
import { NavItem, NavItemIdentifier } from '@/types/navigation';
import { User } from '@/types/user';
import { Variant } from '@amplitude/experiment-js-client';
import { APP_ROUTES } from './pages';

export const navigationDrawerConstants = {
  NAVIGATION_DRAWER: 'NAVIGATION_DRAWER',
};

export type DrawerItem = NavItem & {
  category: 'account' | 'payment' | 'offer' | 'more';
};

const tBase = (key: string) => _s(`headerNavigation.${key}`);

const supportItem: DrawerItem = {
  category: 'more',
  icon: 'support',
  label: tBase('support'),
  to: '/support',
  identifier: NavItemIdentifier.Support,
};

const companyItem = (isMerchant: boolean): DrawerItem => ({
  category: 'more',
  icon: 'company',
  label: isMerchant ? tBase('manageCompany') : tBase('connectCompany'),
  to: isMerchant ? config.merchantUrl : 'https://business.bokadirekt.se/',
  identifier: isMerchant ? NavItemIdentifier.CompanyLogin : NavItemIdentifier.ConnectCompany,
  externalLink: true,
});

const cancelItem: DrawerItem = {
  category: 'account',
  icon: 'calendar-cross',
  label: tBase('cancel'),
  to: '/cancel',
  identifier: NavItemIdentifier.Cancel,
};

const myBundlesItem: DrawerItem = {
  category: 'payment',
  icon: 'punch-card',
  label: tBase('myBundles'),
  to: '/klippkort/giltig',
  identifier: NavItemIdentifier.Bundles,
};

export const myAccountItem: DrawerItem = {
  category: 'account',
  icon: 'account',
  label: tBase('myProfile'),
  to: '/my-profile',
  identifier: NavItemIdentifier.Profile,
};

export const navigationDrawerItems = (user: User, flags: Variant, whitelabel: boolean): DrawerItem[] => {
  const isMerchant = user?.about?.isMerchant;

  return user
    ? [
        {
          category: 'payment',
          icon: 'credit-card',
          label: tBase('paymentMethods'),
          to: '/betalningsmetoder',
          identifier: NavItemIdentifier.PaymentMethods,
        },
        ...getOfferItems(whitelabel, flags),
        myBundlesItem,
        supportItem,
      ]
    : [cancelItem, ...getOfferItems(whitelabel, flags), ...(!whitelabel ? [companyItem(isMerchant)] : []), supportItem];
};

const getOfferItems = (whitelabel: boolean, flags: Variant): DrawerItem[] => {
  const offerItemsOnWhitelabel = [NavItemIdentifier.GiftCardUse, NavItemIdentifier.WellnessCardUse];

  const offerItems: DrawerItem[] = [
    {
      category: 'payment',
      icon: 'wellness-card',
      label: tBase('useWellnessCard'),
      to: '/giftcards',
      identifier: NavItemIdentifier.WellnessCardUse,
    },
    {
      category: 'payment',
      icon: 'gift-card',
      label: tBase('useGiftCard'),
      to: '/giftcards',
      identifier: NavItemIdentifier.GiftCardUse,
    },
    {
      category: 'offer',
      icon: 'gift-card',
      label: tBase('buyGiftCard'),
      to: APP_ROUTES.GIFTCARD_CHECKOUT,
      identifier: NavItemIdentifier.GiftCardBuy,
    },
    {
      category: 'offer',
      icon: 'wellness-card',
      label: tBase('buyWellnessCard'),
      to: APP_ROUTES.WELLNESSCARD_CHECKOUT,
      identifier: NavItemIdentifier.WellnessCardBuy,
    },
  ];
  return offerItems.filter((item) => (whitelabel ? offerItemsOnWhitelabel.includes(item.identifier) : true));
};
